import { useAccountStore } from '@/store/account';
import { NavigationGuardNext, RouteLocationNormalized } from 'vue-router';
import NProgress from 'nprogress';
import 'nprogress/nprogress.css';
import { useInstances } from '@/hooks/use-instances';
import { useAppStore } from '@/store/app';

NProgress.configure({ showSpinner: true });
const { getVueRouterInstance } = useInstances();
const router = getVueRouterInstance();

const pathHandler = (to: RouteLocationNormalized, from: RouteLocationNormalized, next: NavigationGuardNext) => {
  const { token } = useAccountStore();
  const isLogin = token;
  const isLoginPath = to.path === '/login';
  const noMatchRouter = to.matched.length === 0;
  const needAuth = !!to.meta?.auth;
  const redirectUrl = encodeURIComponent(to.fullPath);

  const validators = [
    // 没有匹配对应路由 直接调整404
    { rule: noMatchRouter, params: { path: '/404', replace: true } },
    // 不需要登陆 直接下一步
    { rule: !needAuth },
    // 登陆过 && 进入登陆页面 调整首页
    { rule: isLogin && isLoginPath, params: { path: '/' } },
    // 没有登陆 && 不是登陆页面 调整登陆页面
    { rule: !isLogin && !isLoginPath, params: { path: '/login', query: { redirect: redirectUrl }, replace: true } },
    // 登陆过 && 有权限 直接下一步
    { rule: isLogin },
  ];

  const found = validators.find((valid) => {
    return valid.rule;
  });
  if (found && found.params) {
    next(found.params);
  } else {
    next();
  }
};

// 处理当前用户信息
const handleCurrentUser = async (to: RouteLocationNormalized) => {
  // 处理 根据code 换token
  const accountStore = useAccountStore();
  // 已登陆
  if (accountStore.token && to.name !== 'Login' && to.name !== 'SelectTenant' && to.name !== 'SessionManage') {
    // 获取用户信息
    await accountStore.getAccountInfo();
  }
};

router.beforeEach(async (to, from, next) => {
  NProgress.start();
  const { getEnvConfig } = useAppStore();
  await getEnvConfig();
  await handleCurrentUser(to);
  pathHandler(to, from, next);
});

router.afterEach(() => {
  NProgress.done();
});
